export const CrimeType = {
  VARIOUS_CRIME: "Various Crime",
  CORRUPTION_CRIME: "Corruption Crime",
  ECONOMIC_CRIME: "Economic Crime",
};

export const IncidentStatus = {
  PENDING: "Pending",
  TERMINATED: "Terminated",
  FORWARDED: "Forwarded",
};

export const Gender = {
  Male: "Male",
  Female: "Female",
};

export interface CrimeReferenceReceptionMethod {
  uu_id: number;
  reception_method: string;
  description: string;
}

// interface VictimType {
//   INDIVIDUAL: "individual";
//   NON_GOVERNMENTAL: "non_governmental";
//   GOVERNMENTAL: "governmental";
// }
// interface CrimeReferenceEvidence {
//   uu_id: number;
//   name: string;
// }
// interface CrimeOffenceExhibit {
//   uu_id: number;
//   name: string;
// }
interface ScreeningDecisionType {
  PENDING: "Pending";
  CASE_CLOSE: "Close Case";
  FORWARD_TO_INVESTIGATION: "Forward to Investigation";
}
interface DecisionType {
  uu_id: number;
  name: string;
}

export interface AccusedProsecutor {
  working_id: any;
  uu_id: string;
  english_first_name: string;
  english_middle_name: string;
  english_last_name: string;
  full_name: string;
  employee_type: string | any;
  status: string;
  woreda?: string;
  zone?: string;
  gender?: string;
  admin_unit?: string;
  org_unit?: string;
  mobile_phone_number?: string;
}

export interface AccusedAdvocate {
  id: string;
  application_no: string;
  license_no: string;
  name: string;
  registration_no: string;
  phone?: string;
  gender?: string;
  admin_unit?: string;
}

export interface AssignedProsecutor {
  roles: string[];
  user: Prosecutor;
}

export interface AdminUnit {
  hierarchy_level: any;
  parent_unit: null;
  structure_level: string;
  unit_name: string;
  uu_id: string;
}

export interface Prosecutor {
  uu_id: number;
  id?: string;
  first_name?: string;
  last_name?: string;
  full_name: string;
  work_level: string;
  working_id: string;
  email: string;
  phone_number: string;
  created_at: Date;
}

export interface Police {
  uu_id: number;
  full_name: string;
  work_level: string;
  badge_number: string;
  department: string;
  email: string;
  phone_number: string;
  created_at: Date;
}
export interface CrimeReference {
  uu_id: number;
  crime_reference_number: string;
  date_received?: Date | null;
  crime_type?: keyof typeof CrimeType | null;
  reception_method?: CrimeReferenceReceptionMethod | null;
  category?: string | null;
  receiving_prosecutor?: Prosecutor | null;
  receiving_police?: Police | null;
  description?: string | null;
  status: keyof typeof IncidentStatus;

  crime_incidence_time?: Date | null;
  crime_incident_narrative: string | null;
  victim_status: string | null;
  crime_category: string | null;
  evidence_written: string | null;
  tools_used: string | null;

  crime_incidence_region: string | null;
  crime_incidence_zone: string | null;
  crime_incidence_city: string | null;
  crime_incidence_woreda: string | null;
  crime_incidence_kebele: string | null;
  crime_incidence_site: string | null;

  screening_outcome: ScreeningDecisionType | null;
  follow_up_action: string | null;
  decision_type: DecisionType | null;
  decision_date: Date | null;
}
// interface CrimeReferenceEvidence {
//   uu_id: number;
//   evidence_type: string;
//   description: string;
//   date_collected: Date;
//   collected_by: string;
//   document: string;
//   crime_reference: CrimeReference;
// }

// interface CrimeReferenceExhibit {
//   uu_id: number;
//   tool_type: string;
//   description: string;
//   date_collected: Date;
//   collected_by: string;
//   document: string;
//   crime_reference: CrimeReference;
// }
export interface Suspect {
  uu_id: number;
  crime_reference?: CrimeReference | null;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level?: string | null;

  job_position?: string | null;
  ethnicity?: string | null;
  nationality?: string | null;
  religion?: string | null;
  date_of_birth: Date;
  phone_number?: string | null;
  email?: string | null;
  identity_card_number?: string | null;
  region?: string | null;
  zone?: string | null;
  woreda?: string | null;
  kebele?: string | null;
  house_number?: string | null;
  city?: string | null;

  criminal_record?: string | null;
  statement?: string | null;
  is_in_custody?: Boolean | null;
}

export interface Witness {
  uu_id: number;
  crime_reference?: CrimeReference | null;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level?: string | null;

  job_position?: string | null;
  ethnicity?: string | null;
  nationality?: string | null;
  religion?: string | null;
  date_of_birth: Date;
  phone_number?: string | null;
  email?: string | null;
  identity_card_number?: string | null;
  region?: string | null;
  zone?: string | null;
  woreda?: string | null;
  kebele?: string | null;
  house_number?: string | null;
  city?: string | null;

  testimony?: string | null;
  statement?: string | null;
}

export interface Victim {
  uu_id: number;
  crime_reference?: CrimeReference | null;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level?: string | null;

  job_position?: string | null;
  ethnicity?: string | null;
  nationality?: string | null;
  religion?: string | null;
  date_of_birth: Date;
  phone_number?: string | null;
  email?: string | null;
  identity_card_number?: string | null;
  region?: string | null;
  zone?: string | null;
  woreda?: string | null;
  kebele?: string | null;
  house_number?: string | null;
  city?: string | null;

  injury_details?: string | null;
  statement?: string | null;
}

export interface Governmental {
  uu_id: number;
  governmental_type: string;
  office_name: string;
  department: string;
  address: string;
  crime_reference?: CrimeReference | null;
}

export interface Governmental {
  uu_id: number;
  governmental_type: string;
  office_name: string;
  department: string;
  address: string;
  crime_reference?: CrimeReference | null;
}
export interface NonGovernmental {
  uu_id: number;
  organization_name: string;
  registration_number: string;
  non_governmental_type: string;
  address: string;
  crime_reference?: CrimeReference | null;
}
export interface Evidence {
  uu_id: number;
  evidence_type: string;
  description?: string;
  date_collected?: Date;
  collected_by: string;
  crime_reference?: CrimeReference | null;
}
export interface Exhibit {
  uu_id: number;
  tool_type?: string;
  description?: string;
  date_collected?: Date;
  collected_by?: string;
  crime_reference?: CrimeReference | null;
}
export interface Reporter {
  uu_id: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  gender?: keyof typeof Gender | null;
  age?: number | null;
  education_level: string;
  job_position: string;
  ethnicity: string;
  nationality: string;
  religion: string;
  date_of_birth?: Date | null;
  phone_number: string;
  email: string;
  identity_card_number: string;
  region: string;
  zone: string;
  woreda: string;
  kebele: string;
  house_number: string;
  city: string;
  report_details: string;
  crime_reference?: CrimeReference | null;
}

export interface AdvocateComplaints {
  uu_id: string | number;
  complaint_number?: string;
  receiving_prosecutor?: any;
  user_id_receiving_prosecutor?: string;
  userid_accused_name?: string;
  receiving_prosecutor_name?: string;
  reporters?: Reporter[] | [];
  victims?: Victim[] | [];
  witnesses?: Witness[] | [];
  accused_prosecutor?: AccusedProsecutor | string | null;
  accused_advocate?: AccusedAdvocate | string | null;
  user_id_accused_prosecutor_name?: string;
  accused_name?: string;
  accused_advocate_name?: string;
  user_id_accused_advocate?: string;
  accused_id?: string;
  accused_prosecutor_phone: string;
  assigned_prosecutor_detail?: any;
  assigned_prosecutor?: string | null;
  sex?: string;
  accused_geneder?: string;
  accused_phone_number?: string;
  commission_of_disciplinary_offense_date?: Date | null;
  user_id_assigned_prosecutor?: string;
  userid_assigned_prosecutor?: string;
  admin_unit_id?: string;
  org_id?: string;
  reception_date?: Date | null;
  offence_type: string;
  offence_description: string;
  decision_type?: string | null;
  decision_summary: string;
  assigned_date?: string | null;
  status?: string | null;
  created_at?: string | null;
  createdAt?: string | null;
  has_councile?: boolean;
  has_appeal?: boolean;
  has_accused?: boolean;
  has_courtappeal?: boolean;
  has_councileappeal?: boolean;
  accused_prosecutor_name?: string;
  accused_license_number?: string;
  user_id_accused_advocate_id?: string;

  is_on_advocate_complaint?: boolean;
  is_on_paralegal_complaint?: boolean;
  is_zonal?: boolean;
  is_regional?: boolean;
  report_application_number?: string;
}

export interface Complaints {
  uu_id: string | number;
  complaint_number?: string;
  council_decision_documents?: [];
  is_final_decison_given?: boolean;
  transferred_from_admin_unit_id?: string;
  receiving_prosecutor?: any;
  user_id_receiving_prosecutor?: string;
  admin_unit_id?: string;
  org_id?: string;
  accused_prosecutor_org_id?: string;
  accused_prosecutor_admin_unit_id?: string;
  receiving_prosecutor_name?: string;
  reporters?: Reporter[] | [];
  victims?: Victim[] | [];
  witnesses?: Witness[] | [];
  accused_prosecutor?: AccusedProsecutor | string | null;
  user_id_accused_prosecutor_name?: string;
  accused_prosecutor_name?: string;
  accused_license_number?: string;
  accused_prosecutor_phone: string;
  assigned_prosecutor_detail?: any;
  assigned_prosecutor?: string | null;
  user_id_assigned_prosecutor?: string;
  accused_prosecutor_gender?: string;
  accused_prosecutor_id?: string;
  accused_prosecutor_job_status?: string;
  out_of_jursdicition_source?: string;
  reception_date?: Date | null;
  date_of_offense?: Date | null;
  offence_type: string;
  offence_description: string;
  decision_type?: string | null;
  decision_summary: string;
  assigned_date?: any;
  status?: string | null;
  created_at?: string | null;
  createdAt?: string | null;
  has_councile?: boolean;
  has_appeal?: boolean;
  has_accused?: boolean;
  has_courtappeal?: boolean;
  has_councileappeal?: boolean;
  prosecutor_offence_region?: string;
  prosecutor_offence_zone?: string;
  prosecutor_offence_woreda?: string;

  report_application_number?: string;
  cordinator_id?: string;

  application_number?: string;
  is_regional?: boolean;
}
export const ComplaintStatus = {
  "Under Investigation": "Under Investigation",
  Pending: "Pending",
  Closed: "Closed",
  "Under Litigation": "Under Litigation",
  "Draft Charge": "Draft Charge",
};

export interface LoginAccount {
  access: string;
  refresh: string;
  user_id: number;
  username: string;
  email: string;
  permissions: string[];
  roles: string[];
  employee_id: number;
  admin_unit: number;
  org_unit: number;
  user_type: string;
  is_superuser: boolean;
  full_name: string;
}

export interface CollectedEvidence {
  Collected_by: string;
  Evidence_type: string;
  Collected_date: string;
  Remark: string;
  complaint: any | null;
  attachments: any[];
  files: File[];
}

export interface AdvocateCollectedEvidence {
  collected_by: string;
  evidence_type: string;
  collected_date: string;
  remark: string;
  complaint: any | null;
  attachments: any[];
  files: File[];
}

export interface DocumentEvidence {
  file: File | null;
  document_dms_uuid: string | null;
  evidence: string | null;
}

export interface CollectedVictim {
  name: string;
  address: string;
  phone_number: string;
  email: string;
  victim_region: string;
  victim_zone: string;
  victim_city: string;
  victim_woreda: string;
  victim_kebele: string;
  id_numner: string;
  files: File[];
  complaint: any | null;
}
export interface CollectedReporter {
  name: string;
  address: string;
  phone_number: string;
  email: string;
  reporter_region: string;
  reporter_zone: string;
  reporter_city: string;
  reporter_woreda: string;
  reporter_kebele: string;
  id_numner: string;
  files: File[];
  complaint: any | null;
}
export interface CollectedWitness {
  name: string;
  address: string;
  phone_number: string;
  email: string;
  witness_region: string;
  witness_zone: string;
  witness_city: string;
  witness_woreda: string;
  witness_kebele: string;
  id_numner: string;
  files: File[];
  complaint: any | null;
}

export interface Appeal {
  id?: string | null;
  appeal_documents?: [];
  if_reject_comment?: string | null;
  memorandum_of_disciplinary_appeal?: string | null;
  memorandum_of_disciplinary_appeal_dms_uuid?: string | null;
  memorandum_summary?: string;
  appeal_status?: string | null;
  feedback_on_memorandum?: string;
  feedback_comment?: string;
  appeal_type?: string | null;
  discipline_case?: string | null;
  previous_decision?: string | null;
  requesting_prosecutor?: string | null;
  appeal_feedback_status?: string | null;
  registration_number?: string;
  registration_date?: string | null;
  coordinator_feedbacks?: any;
  userid_requesting_prosecutor?: string;
  createdAt?: string;
  admin_unit_id?: string;
  memorandum_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };

  is_appeal_to_court?: boolean;
  is_appeal_to_general_council?: boolean;
  assigned_prosecutor?: string | null;
  council_office_verdicts?: [];
  evaluations?: [];
}

export interface InvestigationComment {
  investigation: string | null;
  created_at?: string;
  comment: string;
}

export interface Investigation {
  files?: File[];
  documents?: [];
  further_investigations?: FurtherInvestigation[];
  director_feedbacks?: { comment: string }[];
  is_prosecutor_charge_doc?: boolean;
  is_backto_prosecutor?: boolean;
  complaint: any | null;
  uu_id?: string | null;
  complaint_detail?: Complaints;
  investigation_start_date?: string | null;
  investigation_end_date?: string | null;
  prosecutor_decision_type?: string | null;
  prosecutor_decision_summary?: string;
  prosecutor_decision_document?: string | null;
  feedback?: string;
  director_feedbackshargedocument?: [
    { comment: string; created_at: string; id: string },
  ];
  director_charge_feedbacks?: [
    { comment: string; created_at: string; id: string },
  ];
  councilwritercharge_docs?: [
    { comment: string; created_at: string; id: string },
  ];
  council_writer_feedbacks?: [
    { comment: string; created_at: string; id: string },
  ];
  feedback_status?: string;
  feedback_status_charge_docu?: string;
  charge_documents?: string | null;
  charge_document_detail?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  investigation_documents?: {
    created_at: Date;
    document_path: string;
    document_type: string;
    document_uuid: string;
    investigation: string;
    updated_at: Date;
    uu_id: "17b5e1d4-534a-4c61-a3f8-bbea006754a6";
  }[];
  charge_summary?: string;
  artcicle_of_charge?: string;
  charge_article?: string;
  status: string | null;
  registration_number?: string;
  date?: string | null;
  accused_prosecutor_name?: string | null;
  user_id_accused_prosecutor_name?: string | null;

  council_decision_day?: string;
  council_decision_summary?: string;
  is_council_decide_initial_day?: boolean;
  reject_coment_date?: string | null;
  reject_coment?: string;
}

export const InvestigationStatus = {
  "Under Investigation": "Under Investigation",
  Pending: "Pending",
  Closed: "Closed",
  "On Charge": "On Charge",
};

export interface Summon {
  id?: string | null;
  files: File[];
  assiegned_prosecutor?: string;
  assigned_prosecutor?: string;
  documents?: [];
  summon_documents?: [];
  accused_advocate_confirmed?: boolean;
  is_summon_issued?: boolean;
  issue_summon_documents?: [];
  summon_file?: string;
  summon_file_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  accused_response_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  letter_upload_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  summon_file_dms_uuid?: string | null;
  hearing_date: string;
  summary: string;
  region: string;
  zone: string;
  woreda: string;
  kebele: string;
  accused_confirmed?: boolean | null;
  cordinator_confirmed?: boolean | null;
  coordinator_confirmed?: boolean | null;
  accussed_confirmed?: boolean | null;
  investigation: Investigation | null;
  appeal_request?: string | null;
  letter_upload?: string | null;
  status?: string | null;
  accused_prosecutor_name?: string | null;
  accused_response?: string | null;
  user_id_accused_prosecutor_name?: string | null;
}

export interface CourtAppeal {
  id?: string | null;
  documents?: [];
  appeal_documents?: [];
  accused_prosecutor_name?: string;
  admin_unit_id?: string;
  org_id?: string;
  user_id_accused_prosecutor_name?: string;
  user_id_assigned_prosecutor?: string;
  court_summon?: string | null;
  court_summon_file_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  court_summon_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  files?: File[];
  court_summon_dms_uuid?: string | null;
  response?: string | null;
  response_dms_uuid?: string | null;
  court_number: string;
  court_hearing_date: string | null;
  registration_date?: string | null;
  court_name: string;
  hearing_court: string;
  court_order_summon: string;
  registration_number: string;
  status: string | null;
  assigned_prosecutor?: string;
  response_summary?: string;
  response_file_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  discipline_complain?: string | null;
}

export interface AccusedSummon {
  id?: string | null;
  files?: File[];
  assiegned_prosecutor?: string;
  userid_assigned_prosecutor?: string;
  uploaded_documents?: [];
  appeal_documents?: [];
  summon_file?: string;
  summon_file_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  summon_file_dms_uuid?: string | null;
  hearing_date?: string;
  summary?: string;
  region?: string;
  zone?: string;
  woreda?: string;
  kebele?: string;
  claim_summary_file?: string;
  accused_confirmed?: boolean | null;
  cordinator_confirmed?: boolean | null;
  coordinator_confirmed?: boolean | null;
  discipline_complain?: string | null;
  assigned_prosecutor?: string | null;
  assigned_advocate?: string | null;
  status?: string | null;
  response_summary?: string | null;
  response?: string;
  registration_number?: string;
  registration_date?: string;
  prosecutor_opinion_on_decision_appeal?: string;
  claim_summary?: string;
  response_file_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  claim_summary_file_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  coordinator_feedbacks?: any;
  is_appeal_to_general_council?: boolean;
}

export interface Litigation {
  id?: string;
  verdict_documents?: [];
  documents?: [];
  council_decision?: string | null;
  council_decision_dms_uuid?: string | null;
  termination_document?: string | null;
  termination_document_dms_uuid?: string | null;
  hearing_date: string;
  createdAt?: string;
  given_order?: string;
  daily_report_summary: string;
  add_new_witness?: string;
  next_appointment_date: string;
  appointment_reason: string;
  is_final_verdict_given: boolean;
  council_decision_summary?: string;
  council_decision_day?: string | null;
  prosecutor_opinion_on_decision?: string;
  assigned_prosecutor?: string;
  termination_reason?: string;
  prosecutor_opinion_on_decision_appeal?: string;
  council_decision_type?: string;
  discipline_measure_type?: string;
  ammended_council_decision_type?: string;
  ammended_discipline_measure_type?: string;
  remaining_days_for_appeal?: number | null;
  user_id_re_assign_prosecutor?: string;
  user_id_assigned_prosecutor?: string;
  re_assign_prosecutor?: string | null;
  summon_detail?: Summon;
  summon: string | null;
  summonappeal_accusepProsecutor?: string | null;
  summon_appeal_accused_advocate?: string | null;
  appealto_court?: string | null;
  appeal_to_court?: string | null;
  appeal_request?: string | null;
  director_feedbacks?: [
    {
      comment: string;
      created_at: string;
      id: string;
    },
  ];
  director_feedbacks_appeal?: [
    {
      comment: string;
      created_at: string;
      id: string;
    },
  ];
}

export interface CouncilLitigation {
  id?: string;
  documents?: [];
  verdict_documents?: [];
  advocate_claim_summary?: string;
  accused_claim_file?: string;
  initial_day_verdicts?: CouncilOfficeVerdictInitialDay[];
  verdict_given_on_intialday_ins?: boolean;
  response_from_general_council?: string;
  council_decision_documents?: [];
  accused_prosecutor_name?: string;
  council_decision?: string | null;
  council_decision_dms_uuid?: string | null;
  termination_document?: string | null;
  termination_document_dms_uuid?: string | null;
  hearing_date: string;
  given_order?: string;
  daily_report_summary: string;
  next_appointment_date: string;
  appointment_reason: string;
  is_final_verdict_given: boolean;
  council_decision_summary?: string;
  council_decision_day?: string | null;
  council_decision_type?: string;
  discipline_measure_type?: string;
  ammended_council_decision_type?: string;
  ammended_discipline_measure_type?: string;
  claim_summary_file?: string;
  claim_summary?: string;
  createdAt?: string;
  termination_reason?: string;
  remaining_days_for_appeal?: number | null;
  summon_detail?: Summon;
  attendances?: any[];
  council_decision_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  meeting_file_details?: {
    file_name: string;
    url: string;
    dms_uuid: string;
  };
  summon: string | null;
  summonappeal_accusepProsecutor?: string | null;
  summon_appeal_accused_advocate?: string | null;
  appealto_court?: string | null;
  appeal_to_court?: string | null;
  appeal_request?: string | null;
}
export interface MobileDeciplineReport {
  id?: string | number;
  report_application_number?: string;
  complainant_name?: string;
  complainant_phone?: string;
  complainant_email?: string;
  accused_prosecutor_name?: string;
  accused_license_number?: string;
  accused_prosecutor_gender?: string | null;
  date_of_offense?: Date | null;
  offence_description?: string;
  region?: string;
  city_zone?: string;
  sub_city?: string;
  kebele?: string;
  kebele_woreda?: string;
  house_number?: string;
  status?: "Pending" | "Reviewed" | "Closed";
  is_on_prosecutor?: boolean;
  is_on_advocate?: boolean;
}
export interface CouncilOfficeVerdictInitialDay {
  id?: string | null;
  accused_prosecutor_name?: string;
  user_id_accused_prosecutor_name?: string;
  given_order?: string;
  council_decision_summary?: string;
  council_decision_day?: Date;
  council_decision_type?: string;
  org_id?: string;
  admin_unit_id?: string;
  remaining_days_for_appeal?: number;
  verdict_given_on_intialday_ins?: boolean;
  verdict_given_on_intialday_accused?: boolean;
  original_verdict?: number | CouncilLitigation;
  appeal_request_ins_prosecutor?: number | Appeal;
  initial_day_council_decision_files?: File;
  documents?: [];
}
export const OFFENCE_TYPE_FOR_ADVOCATE = {
  grave: "Grave offense",
  medium: "Medium offense",
  petty: "Petty offense",
};
export interface FurtherInvestigation {
  id?: number;
  comment: string;
  investigation: number;
}
